var _defs, _g, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayerPortrait12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.4583in",
    height: "1.4583in",
    viewBox: "0 0 37.042 37.042",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1132",
    x1: 54.811,
    x2: 91.853,
    y1: 32.815,
    y2: 32.815,
    gradientTransform: "translate(81.006 99.907)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3a995",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4-2",
    x1: -79.698,
    x2: -64.181,
    y1: 89.937,
    y2: 89.937,
    gradientTransform: "matrix(-3.5433 0 0 4.0316 -184.9 -338.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7e7867",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6-4",
    x1: -46.42,
    x2: -41.591,
    y1: 168.81,
    y2: 168.81,
    gradientTransform: "matrix(1.5385 0 0 .64997 -86.896 24.616)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a19a86",
    offset: 0
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-135.82 -114.2)",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 215.9,
    height: 279.4,
    fill: "#fcfcfc",
    style: {
      paintOrder: "markers fill stroke"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-135.82 -114.2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.82,
    y: 114.2,
    width: 37.042,
    height: 37.042,
    ry: 2.0045,
    fill: "url(#linearGradient1132)",
    style: {
      paintOrder: "normal"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#413e35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m157.8 124.05a3.5881 4.0044 0 0 0-0.30142 1.6059 3.5881 4.0044 0 0 0 3.5881 4.0045 3.5881 4.0044 0 0 0 3.5881-4.0045 3.5881 4.0044 0 0 0-0.30202-1.6059z",
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.18,
    cy: 126.94,
    r: 2.7925,
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.28 128.38a3.9464 3.9464 0 0 0-0.44456 5.5389l2.5454 3.0161a3.9464 3.9464 0 0 0 0.47033-5.5612l-2.5451-3.0157a3.9464 3.9464 0 0 0-0.0261 0.0222z",
    stopColor: "#000000"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 135.82 114.2)",
    d: "m70 23.994c-6.2387 0-11.978 2.0609-16.582 5.5371v0.001953a12.892 12.892 0 0 1 2.6523 7.8301 12.892 12.892 0 0 1-12.893 12.893 12.892 12.892 0 0 1-0.63086-0.019531c-0.018964 0.41452-0.037109 0.82862-0.037109 1.248v7.5781c0 15.229 12.261 27.49 27.49 27.49 13.602 0 24.826-9.7825 27.072-22.723l-3.0723-3.6406a10.029 10.029 0 0 1-1.668-10.133 12.892 12.892 0 0 1-10.682-12.695 12.892 12.892 0 0 1 3.5059-8.834c-4.3405-2.8642-9.545-4.5332-15.156-4.5332zm15.156 4.5332c1.2535 0.82705 2.4337 1.7538 3.5312 2.7695-1.0974-1.0159-2.2779-1.9425-3.5312-2.7695zm3.5312 2.7695c0.35739 0.33076 0.70564 0.67228 1.0449 1.0215-0.33938-0.34941-0.68743-0.69054-1.0449-1.0215zm-46.141 18.939c0.001959-0.042814 0.001752-0.086145 0.003906-0.12891-0.002117 0.043332-0.007842 0.085518-0.009765 0.12891a12.892 12.892 0 0 0 0.005859 0zm0.003906-0.12891c0.030194-0.618 0.076443-1.2315 0.14648-1.8379-0.070027 0.60617-0.11537 1.2204-0.14648 1.8379zm8.0664-18.148c-0.085274 0.084652-0.16975 0.1701-0.25391 0.25586 0.083987-0.085584 0.16881-0.17138 0.25391-0.25586zm39.191 0.4375c0.29921 0.31042 0.5906 0.62886 0.875 0.95312-0.28443-0.3244-0.57575-0.64258-0.875-0.95312zm1.0469 1.1523c0.27599 0.32083 0.54552 0.64692 0.80664 0.98047-0.26113-0.33366-0.53063-0.65953-0.80664-0.98047zm0.89844 1.0996c0.2853 0.36859 0.56155 0.74369 0.82812 1.127-0.26638-0.38306-0.54305-0.75855-0.82812-1.127zm0.86133 1.1719c0.2815 0.40648 0.55281 0.82201 0.8125 1.2441-0.25989-0.42258-0.53077-0.83724-0.8125-1.2441zm0.8125 1.2441c0.52525 0.85379 1.0045 1.7375 1.4355 2.6504-0.43102-0.91296-0.91038-1.7965-1.4355-2.6504zm1.4355 2.6504c0.20796 0.44041 0.40299 0.88878 0.58789 1.3418-0.18491-0.45311-0.37992-0.90129-0.58789-1.3418zm0.65039 1.5c0.15885 0.39622 0.3085 0.7979 0.44922 1.2031-0.14074-0.40532-0.29035-0.8068-0.44922-1.2031zm0.55078 1.5c0.12196 0.36466 0.23484 0.73211 0.3418 1.1035-0.10693-0.37129-0.21988-0.73895-0.3418-1.1035zm0.43555 1.4375c0.1093 0.3985 0.21106 0.80139 0.30273 1.207-0.091779-0.40619-0.19329-0.80799-0.30273-1.207zm0.35156 1.4199c0.095263 0.43772 0.17965 0.87883 0.25391 1.3242-0.074198-0.445-0.15874-0.88686-0.25391-1.3242zm0.28516 1.5059c0.080129 0.50131 0.14834 1.0074 0.20117 1.5176l0.003906 0.003906c-0.052923-0.51186-0.12467-1.0185-0.20508-1.5215z",
    fill: "url(#4-2)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m149.95 122.01c-1.6735 1.2637-2.7785 3.2356-2.8779 5.4782a3.4109 3.4109 0 0 0 0.16846 5e-3 3.4109 3.4109 0 0 0 3.4112-3.4112 3.4109 3.4109 0 0 0-0.70176-2.0717z",
    fill: "#413e35",
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "scale(-1,1)",
    cx: -157.87,
    cy: 129.38,
    rx: 2.0398,
    ry: 1.4861,
    fill: "#d3cdc3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "scale(-1,1)",
    cx: -157.87,
    cy: 129.38,
    rx: 0.885,
    ry: 1.2626,
    fill: "#413e35",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "scale(-1,1)",
    cx: -150.8,
    cy: 129.38,
    rx: 2.0398,
    ry: 1.4861,
    fill: "#d3cdc3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "scale(-1,1)",
    cx: -150.8,
    cy: 129.38,
    rx: 0.885,
    ry: 1.2626,
    fill: "#413e35",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(-1,1)",
    x: -158.32,
    y: 134.34,
    width: 7.4291,
    height: 3.1385,
    fill: "url(#6-4)",
    stopColor: "#000000",
    strokeOpacity: 0.019685,
    strokeWidth: 3.7294,
    style: {
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m158.35 121.75a3.4109 3.4109 0 0 0-0.92759 2.3373 3.4109 3.4109 0 0 0 3.4112 3.4112 3.4109 3.4109 0 0 0 0.76739-0.0879c-0.13181-2.3719-1.3898-4.4326-3.251-5.6606z",
    fill: "#413e35",
    stopColor: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m160.99 126.4a2.6536 2.6536 0 0 0-0.29893 3.7244l1.7115 2.028a2.6536 2.6536 0 0 0 0.31626-3.7394l-1.7114-2.0278a2.6536 2.6536 0 0 0-0.0175 0.0149z",
    fill: "#413e35",
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 135.82 114.2)",
    d: "m48.426 18.533c-0.69494 0-1.1492 0.52256-1.2539 1.2305l-2.5664 17.354h-16.047v3.1523h82.883v-3.1523h-16.055l-2.6934-17.354c-0.1062-0.68542-0.55885-1.2305-1.2539-1.2305h-43.014z",
    fill: "#d3cdc3",
    stopColor: "#000000",
    strokeOpacity: 0.019685,
    strokeWidth: 19.496,
    style: {
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 135.82 114.2)",
    d: "m31.535 69.297 9.377 25.881a45.897 50.26 0 0 0-16.809 38.844v5.9785h91.793v-5.9785a45.897 50.26 0 0 0-16.799-38.871l9.3672-25.854h-28.047l-5.3594 14.793a45.897 50.26 0 0 0-5.1641-0.32812 45.897 50.26 0 0 0-4.9531 0.32812l-5.3594-14.793h-28.047z",
    fill: "#d3cdc3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait12);
export default __webpack_public_path__ + "static/media/player-portrait-12.75b3f4dbed6f7f748489890501685d58.svg";
export { ForwardRef as ReactComponent };